var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-b border-dashed border-secondary-20 m-2",on:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }